import React from 'react';
import LayoutDashboard from '../layout/LayoutDashboard';
import { Icon } from '@iconify/react';
import baselineMultilineChart from '@iconify/icons-ic/baseline-multiline-chart';
import baselineInsertChart from '@iconify/icons-ic/baseline-insert-chart';
import baselineRefresh from '@iconify/icons-ic/baseline-refresh';
import fileTextFilled from '@iconify/icons-ant-design/file-text-filled';

import CardPieChart from '../components/Dashboard/CardPieChart';
import CardProfit from '../components/Dashboard/CardProfit';
import CardTransaction from '../components/Dashboard/CardTransaction';

// Import Date picker

function Dashboard() {
  return (
    <>
      <LayoutDashboard>
        <div className="mx-2 w-full">
          <div className="flex w-full">
            <div className="w-full md:w-3/12 px-2">
              <div className="rounded-lg shadow-sm mb-4">
                <div className="rounded-lg bg-white shadow-lg md:shadow-xl relative overflow-hidden">
                  <div className="px-6  py-12 text-center  flex">
                    <span className="w-5/12">
                      {' '}
                      <Icon
                        icon={baselineMultilineChart}
                        className="w-full h-16 text-green-700"
                      />
                    </span>
                    <div className="flex flex-col w-7/12">
                      <div className="text-2xl text-green-700  leading-tight">
                        100.000.000
                      </div>
                      <div className="text-lg">OMZET</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="w-full md:w-3/12 px-2">
              <div className="rounded-lg shadow-sm mb-4">
                <div className="rounded-lg bg-white shadow-lg md:shadow-xl relative overflow-hidden">
                  <div className="px-6  py-12 text-center  flex">
                    <span className="w-5/12">
                      {' '}
                      <Icon
                        icon={fileTextFilled}
                        className="w-full h-16 text-orange-400"
                      />
                    </span>
                    <div className="flex flex-col w-7/12">
                      <div className="text-2xl text-orange-400  leading-tight">
                        50.000.000
                      </div>
                      <div className="text-lg">OMZET HARI INI</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="w-full md:w-3/12 px-2">
              <div className="rounded-lg shadow-sm mb-4">
                <div className="rounded-lg bg-white shadow-lg md:shadow-xl relative overflow-hidden">
                  <div className="px-6  py-12 text-center  flex">
                    <span className="w-5/12">
                      {' '}
                      <Icon
                        icon={baselineRefresh}
                        className="w-full h-16 text-blue-400"
                      />
                    </span>
                    <div className="flex flex-col w-7/12">
                      <div className="text-2xl text-blue-400  leading-tight">
                        62.49%
                      </div>
                      <div className="text-lg">KENAIKAN OMZET</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="w-full md:w-3/12 px-2">
              <div className="rounded-lg shadow-sm mb-4">
                <div className="rounded-lg bg-white shadow-lg md:shadow-xl relative overflow-hidden">
                  <div className="px-6  py-12 text-center  flex">
                    <span className="w-5/12">
                      {' '}
                      <Icon
                        icon={baselineInsertChart}
                        className="w-full h-16 text-gray-700"
                      />
                    </span>
                    <div className="flex flex-col w-7/12">
                      <div className="text-2xl text-gray-700  leading-tight">
                        34.56%
                      </div>
                      <div className="text-lg">PENGGUNA BARU</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Chart JS */}
          <div className="flex w-full mt-4">
            <div className="w-full md:w-6/12 px-2">
              <CardProfit />
            </div>
            <div className="w-full md:w-6/12 px-2">
              <CardTransaction />
            </div>
          </div>
          {/* End Cart */}
          {/* Chart Pie */}
          <CardPieChart />
          {/* End Chart Pie */}
        </div>
      </LayoutDashboard>
    </>
  );
}
export default Dashboard;
